module.exports = __webpack_public_path__ + "media/images/products/about/coins-bb5a7ed8e85e54c4a3df75af8ad969ca.png";